/**
 * Unregisters the active service worker, and reloads the page.
 */
export async function unregisterAndReload() {
    const registration = await window.navigator.serviceWorker.getRegistration();
    await registration.unregister();

    window.location.reload();
}
